import { Backdrop, Box, CircularProgress } from "@mui/material";
import React from "react";

export interface BlockUIProps {
  active: boolean;
  children: React.ReactNode;
}

export function BlockUI(props: BlockUIProps) {
  const { active, children } = props;

  return (
    <Box className="relative z-0 w-full">
      <Backdrop
        className="absolute rounded-md opacity-[0.3]"
        open={active}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {children}
    </Box>
  );
}
